import { Farm } from './farm';
import { UserGroup } from './userGroup';
import { UiMode } from '../../../assets/data/enum/uiMode';
import { UserSettings } from './userSettings';

export type LegalLog = {
  id?: number;
  date: Date;
  user?: number;
  legalTemplate: number;
  legalTemplateOption?: number;
  legalTemplateOptionType?: string;
  value: boolean;
};

export class User {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  pictureUrl: string;
  enabled: boolean;
  accountExpired: boolean;
  accountLocked: boolean;
  passwordExpired: boolean;
  password: string;
  farm: Farm;
  welcomeCheck: boolean;
  authorities: Array<any>;
  yearDefault: number;
  userSettings: UserSettings;
  userMultiFarmToken?: string;
  temporary: boolean;
  legalLog?: Array<LegalLog>;
  preferredLanguage: string;
  preferredCountry: string;
  preferredMode: UiMode;
  userGroup: UserGroup;
  userGroupId?: number;
  enabledOnlyPersonalActivity: boolean;
  attemptNo?: number;
  name?: string;
  dateCreated: Date | string;
  lastUpdated: Date | string;

  constructor() {
    this.id = null;
    this.firstName = null;
    this.lastName = null;
    this.username = null;
    this.pictureUrl = null;
    this.enabled = true;
    this.accountExpired = null;
    this.accountLocked = null;
    this.passwordExpired = null;
    this.farm = null;
    this.welcomeCheck = null;
    this.authorities = null;
    this.yearDefault = null;
    this.userSettings = null;
    this.userMultiFarmToken = null;
    this.temporary = false;
    this.preferredMode = UiMode.FARM;
    this.userGroup = null;
    this.userGroupId = null;
    this.enabledOnlyPersonalActivity = null;
    this.lastUpdated = null;
    this.dateCreated = null;
  }
}
